// 메신저(MM) iframe 에 주입하는 '스티커를 글 위로' CSS — 글과 스티커를 함께 보낸 게시물에서 스티커를 글보다 위에 그린다.
// 왜 화면 순서만 바꾸나: 글+스티커는 MM 이 게시물 1개(message + file_ids)로 보내고, MM 11.11 은 한 게시물 안에서
//    글을 위·첨부를 아래에 그린다 → 사용자에게는 «글이 먼저, 스티커가 다음» 으로 보인다.
//    보내는 방식(게시물 1개 · 알림 1건)은 그대로 두고 표시 순서만 바꾼다(게시물을 둘로 쪼개 보내지 않는다).
// 왜 CSS 주입인가: 게시물 본문(.post__body)은 MM 웹앱 마크업이라 우리가 고칠 수 없고,
//    같은 오리진 iframe 이라 통제 지점은 그 문서의 style 요소뿐이다(mmStickerSizeCss·mmPostEditCss 선례).
// 왜 새 모듈인가: mmStickerSizeCss.test.js 가 «그 파일의 규칙은 하나뿐» 을 단언한다 → 거기에 더하지 않는다.
// 🔴 .file-view--single 은 .post__body 의 직계 자식이다(MM 11.11 번들 — 첨부 1장이면 래퍼 없이 그 div 를 그대로 돌려준다).
//    `> :has(.file-view--single …)` 로 쓰면 :has() 안 선택자가 자기 자신을 못 채워 아무것에도 안 걸린다.
// 🔴 스티커 판별은 mmStickerSizeCss 와 같은 문자열(앞 공백 포함) — 일반 사진·파일 게시물은 안 걸린다.
// 🔴 compact 표시(.post--compact)는 뺀다 — 이름(.post__header)이 float 라 flex 본문(새 BFC)이 이름 아래로 밀린다.
// 🔴 :has() 미지원 브라우저는 이 규칙 전체를 무시한다 = 지금 모양(글 위·스티커 아래) 그대로 — 깨지지 않는다.
// 🔴 flex column 의 기본 align-items:stretch 는 블록의 가로 채움과 같다 → 글 줄바꿈·폭은 그대로다
//    (flex 항목은 마진 병합이 없어 첨부 위아래 간격이 수 px 달라질 수 있다 — 허용).
export const MM_STICKER_ORDER_STYLE_ID = 'gw-mm-sticker-order-css';

const STICKER_IMG = 'img[aria-label*=" sticker_"]';
const BODY = '.post:not(.post--compact) .post__body';

export const MM_STICKER_ORDER_CSS = [
  // ① 스티커 첨부가 직계 자식으로 든 게시물 본문만 세로 flex 로 바꾼다(그래야 order 가 먹는다).
  `${BODY}:has(> .file-view--single ${STICKER_IMG}){display:flex !important;flex-direction:column !important}`,
  // ② 그 스티커 첨부를 맨 위로 — 글 슬롯(.AutoHeight)보다 위, 반응·읽음 줄은 그대로 아래.
  `${BODY} > .file-view--single:has(${STICKER_IMG}){order:-1 !important}`,
].join('');

// style#gw-mm-sticker-order-css 를 head 에 '1개만' 유지한다. 폴링 루프(50ms×120)+onLoad 가 반복
// 호출하므로 멱등이 필수 — 이미 있으면 새로 만들지 않고 내용이 달라졌을 때만 갱신한다.
// doc·head 가 없으면(로드 중 문서) 조용히 no-op — applyMmStickerSizeCss 와 같은 형태.
export function applyMmStickerOrderCss(doc) {
  if (!doc || !doc.head) return;
  const found = doc.getElementById(MM_STICKER_ORDER_STYLE_ID);
  if (found) {
    if (found.textContent !== MM_STICKER_ORDER_CSS) found.textContent = MM_STICKER_ORDER_CSS;
    return;
  }
  const st = doc.createElement('style');
  st.id = MM_STICKER_ORDER_STYLE_ID;
  st.textContent = MM_STICKER_ORDER_CSS;
  doc.head.appendChild(st);
}
